/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-truckout': {
    width: 10,
    height: 11,
    viewBox: '0 0 10 11',
    data: '<defs><path pid="0" d="M4.645 1.008a.456.456 0 0 1 .396.036L9.325 3.62l.064.047a.456.456 0 0 1 .157.344v6.51l-.007.082a.456.456 0 0 1-.45.375H.522l-.082-.008a.456.456 0 0 1-.375-.449l.008-.082a.456.456 0 0 1 .449-.374h8.114V4.27l-3.83-2.303L.978 4.27v2.188L.97 6.54a.456.456 0 0 1-.906-.082V4.012l.007-.078a.456.456 0 0 1 .214-.313L4.57 1.044zm.183 3.58a.456.456 0 0 1 .574.109l.047.068a.456.456 0 0 1-.109.574l-1.383 1.14 1.386 1.16.058.058a.456.456 0 0 1-.644.642L2.95 6.827l-.065-.067a.457.457 0 0 1 .067-.635l1.808-1.49z" id="svgicon-icon-truckout-a"/></defs><use _fill="#376F99" transform="matrix(-1 0 0 1 9.61 0)" xlink:href="#svgicon-icon-truckout-a" fill-rule="evenodd"/>'
  }
})
